exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pix-member-circle[data-v-f9a090ca] {\r\n  border-radius: 50%;\r\n  background-color: #ebecec;\r\n  border: solid 1px #b1b2b4;\r\n  /* padding: 4px; */\r\n  font-size: 14px;\r\n  margin-left: -5px;\r\n  /* max-height: 28.27px;\r\n  max-width: 28.27px;\r\n  min-width: 27.27px;\r\n  text-align: center; */\r\n  transition: background 0.2s ease-in;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 28px;\r\n  min-height: 28px;\n}\n.pix-member-circle--clickable[data-v-f9a090ca]:hover {\r\n  cursor: pointer;\r\n  background-color: var(--jll-concrete);\n}\r\n", ""]);

// exports
